
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"3.125 -3.125 9.75 16\" id=\"icon-chevron-right\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M5.199-2.991l7.543,7.542c0.044,0.045,0.078,0.097,0.1,0.152c0.021,0.055,0.033,0.113,0.033,0.172\r\n\tc0,0.117-0.044,0.234-0.134,0.324l-1.292,1.293c0,0-0.002,0-0.002,0.001l-6.249,6.248c-0.179,0.178-0.468,0.178-0.646,0L3.26,11.448\r\n\tc-0.179-0.179-0.179-0.468,0-0.646l5.925-5.927L3.259-1.051c-0.179-0.18-0.179-0.469,0-0.647l1.293-1.293\r\n\tC4.73-3.169,5.02-3.169,5.199-2.991z\"/> </symbol>";
module.exports = sprite.add(image, "icon-chevron-right");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/chevron-right.svg
 ** module id = 158
 ** module chunks = 24
 **/